import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { EmailVerificationStatus } from '@graphql/reactQuery';
import { ResendVerificationEmail } from './ResendVerificationEmail';

export const getStatusMessage = ({
  status,
  requiredVerification,
}: {
  status?: EmailVerificationStatus;
  requiredVerification?: boolean;
}) => {
  if (status === EmailVerificationStatus.NotSet && requiredVerification) {
    return <p className="text-base500">Email verification is required.</p>;
  }
  if (status === EmailVerificationStatus.Expired) {
    return (
      <>
        Verification expired. <ResendVerificationEmail />
      </>
    );
  }

  if (status === EmailVerificationStatus.Pending) {
    if (requiredVerification) {
      return (
        <p className="font-base text-base-s">
          Email verification is required. Please check your email to verify or{' '}
          <ResendVerificationEmail isError />
        </p>
      );
    }
    return (
      <>
        Not verified. <ResendVerificationEmail />
      </>
    );
  }

  if (status === EmailVerificationStatus.Verified) {
    return (
      <div className="flex items-center gap-1">
        <FontAwesomeIcon icon={faCircleCheck} />
        Verified
      </div>
    );
  }

  if (status === EmailVerificationStatus.VerifiedWithOtp) {
    return (
      <div className="flex items-center gap-1">
        <FontAwesomeIcon icon={faCircleCheck} />
        Verified through email sign-in
      </div>
    );
  }

  return '';
};
